module.exports = __webpack_public_path__ + "yetu_banner.png?4b21035daa88deab0cc55bd48580c586";